{
  "version": "1.0.0",
  "name": "Scrum Framework",
  "description": "Agile Scrum methodology with sprint-based workflow and defined roles",
  "state_transitions": {
    "review": {
      "from": [
        "draft"
      ],
      "requires": {
        "command": "gitgov task submit",
        "signatures": {
          "__default__": {
            "role": "product_owner",
            "capability_roles": [
              "product:owner"
            ],
            "min_approvals": 1
          }
        }
      }
    },
    "ready": {
      "from": [
        "review"
      ],
      "requires": {
        "command": "gitgov task approve",
        "custom_rules": [
          "task_fits_in_sprint_capacity"
        ]
      }
    },
    "active": {
      "from": [
        "ready",
        "paused"
      ],
      "requires": {
        "event": "sprint_started",
        "custom_rules": [
          "task_assigned_to_team_member"
        ]
      }
    },
    "done": {
      "from": [
        "active"
      ],
      "requires": {
        "command": "gitgov task complete",
        "signatures": {
          "__default__": {
            "role": "scrum_master",
            "capability_roles": [
              "scrum:master"
            ],
            "min_approvals": 1
          }
        }
      }
    },
    "archived": {
      "from": [
        "done"
      ],
      "requires": {
        "event": "changelog_record_created"
      }
    },
    "paused": {
      "from": [
        "active",
        "review"
      ],
      "requires": {
        "event": "feedback_blocking_created"
      }
    }
  },
  "custom_rules": {
    "task_fits_in_sprint_capacity": {
      "description": "Task story points must fit within remaining sprint capacity",
      "validation": "sprint_capacity"
    },
    "task_assigned_to_team_member": {
      "description": "Task must be assigned to an active team member",
      "validation": "assignment_required"
    }
  },
  "view_configs": {
    "scrum-board": {
      "columns": {
        "Product Backlog": [
          "draft"
        ],
        "Sprint Backlog": [
          "review",
          "ready"
        ],
        "In Progress": [
          "active"
        ],
        "Done": [
          "done"
        ],
        "Retrospective": [
          "archived"
        ]
      },
      "theme": "default",
      "layout": "horizontal"
    },
    "scrum-detailed": {
      "columns": {
        "Product Backlog": [
          "draft"
        ],
        "Groomed": [
          "review"
        ],
        "Sprint Ready": [
          "ready"
        ],
        "In Development": [
          "active"
        ],
        "Demo Ready": [
          "done"
        ],
        "Sprint Closed": [
          "archived"
        ],
        "Blocked": [
          "paused"
        ]
      },
      "theme": "corporate",
      "layout": "vertical"
    },
    "scrum-product-owner": {
      "columns": {
        "Backlog Items": [
          "draft"
        ],
        "Ready for Sprint": [
          "review"
        ],
        "Sprint Committed": [
          "ready"
        ],
        "In Development": [
          "active"
        ],
        "Ready for Review": [
          "done"
        ],
        "Released": [
          "archived"
        ],
        "Issues": [
          "paused",
          "discarded"
        ]
      },
      "theme": "minimal",
      "layout": "grid"
    },
    "scrum-developer": {
      "columns": {
        "To Do": [
          "ready"
        ],
        "In Progress": [
          "active"
        ],
        "Code Review": [
          "done"
        ],
        "Done": [
          "archived"
        ],
        "Blocked": [
          "paused"
        ]
      },
      "theme": "dark",
      "layout": "horizontal"
    },
    "scrum-master-dashboard": {
      "columns": {
        "Sprint Planning": [
          "draft",
          "review"
        ],
        "Active Sprint": [
          "ready",
          "active"
        ],
        "Sprint Review": [
          "done"
        ],
        "Retrospective": [
          "archived"
        ],
        "Impediments": [
          "paused",
          "discarded"
        ]
      },
      "theme": "corporate",
      "layout": "grid"
    }
  },
  "agent_integration": {
    "description": "Agent integration proposal for Scrum methodology automation",
    "required_agents": [
      {
        "id": "agent:scrum-master",
        "engine": {
          "type": "local",
          "entrypoint": "@gitgov/agent-scrum-master"
        },
        "triggers": [
          {
            "event": "sprint_end_approaching",
            "action": "create_sprint_review_tasks"
          },
          {
            "event": "daily_standup_time",
            "action": "generate_standup_report"
          },
          {
            "event": "impediment_detected",
            "action": "escalate_to_product_owner"
          }
        ],
        "knowledge_dependencies": [
          "blueprints/scrum_ceremonies.md",
          "blueprints/impediment_resolution.md"
        ]
      },
      {
        "id": "agent:product-owner-assistant",
        "engine": {
          "type": "mcp",
          "url": "http://localhost:8080/product-owner-mcp"
        },
        "triggers": [
          {
            "event": "backlog_grooming_needed",
            "action": "prioritize_product_backlog"
          },
          {
            "event": "sprint_planning_started",
            "action": "assist_sprint_planning"
          }
        ],
        "knowledge_dependencies": [
          "blueprints/product_vision.md",
          "blueprints/user_stories_template.md"
        ]
      }
    ],
    "automation_rules": [
      {
        "trigger": "sprint_started",
        "agent": "agent:scrum-master",
        "action": "create_daily_standup_tasks"
      },
      {
        "trigger": "task_blocked_for_24h",
        "agent": "agent:scrum-master",
        "action": "escalate_impediment"
      },
      {
        "trigger": "sprint_capacity_exceeded",
        "agent": "agent:product-owner-assistant",
        "action": "suggest_scope_reduction"
      }
    ]
  }
}